import React from 'react';
import { Box, Typography } from '@mui/material';
import { ProvenanceTab, ProvenanceSectionId } from '../wizard/ProvenanceTab';

interface StepProps {
  catalogItemId?: string;
  ownerId?: string | null;
}

const SECTIONS: ReadonlySet<ProvenanceSectionId> = new Set<ProvenanceSectionId>([
  'provenance-publications',
]);

const NOTE =
  'Provide references to publications, catalogs, or articles where this object has been featured. Include titles, authors, and publication dates if available.';

/** Publications promoted from ProvenanceTab into its own step. */
export const PublicationsStep: React.FC<StepProps> = ({ catalogItemId, ownerId }) => (
  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
    <Typography
      variant="body2"
      color="text.secondary"
      data-testid="publications-step-note"
    >
      {NOTE}
    </Typography>
    <ProvenanceTab
      catalogItemId={catalogItemId}
      ownerId={ownerId}
      visibleSections={SECTIONS}
      flatSections
    />
  </Box>
);
